// Phase 129 Plan 04 Task 1 — Sandbox phone formatter.
// Mirrors frontend/src/lib/format-sandbox-phone.ts verbatim so the demo card
// renders the sandbox number as a real contact (e.g. '+972 55 704 6276')
// instead of a concatenated digit string.
//
// IMPORTANT: designed ONLY for raw env-var digits (NO leading +). Don't pass
// already-'+'-prefixed phone strings — output will double-prefix.
export function formatSandboxPhone(raw: string): string {
  if (raw.length === 12 && raw.startsWith('972')) {
    return `+${raw.slice(0, 3)} ${raw.slice(3, 5)} ${raw.slice(5, 8)} ${raw.slice(8)}`;
  }
  if (raw.length === 11 && raw.startsWith('1')) {
    return `+${raw.slice(0, 1)} ${raw.slice(1, 4)}-${raw.slice(4, 7)}-${raw.slice(7)}`;
  }
  return `+${raw}`;
}
